var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHowfasteffect = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 670,
  height: 670,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#howfast_effect_svg__a)",
  opacity: 0.7
}, /*#__PURE__*/React.createElement("circle", {
  cx: 335,
  cy: 334.999,
  r: 135,
  fill: "url(#howfast_effect_svg__b)"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "howfast_effect_svg__b",
  x1: 335,
  x2: 335,
  y1: 199.999,
  y2: 469.999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#48C9FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.475,
  stopColor: "#9D0FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.945,
  stopColor: "#FFA928"
})), /*#__PURE__*/React.createElement("filter", {
  id: "howfast_effect_svg__a",
  width: 670,
  height: 670,
  x: 0,
  y: -0.001,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_20508_13190",
  stdDeviation: 100
})))));
export { SvgHowfasteffect as ReactComponent };
export default __webpack_public_path__ + "static/media/howfast.effect.17bdb2ed.svg";